import React from 'react';
import { AmbianceBand } from '../Ambiance/AmbianceBand';
import { useAmbiance } from '../Ambiance/AmbianceContext';
import { Pill } from '../Vitrine/VitrineUi';
import { VitrineLayout, useDemoButton } from '../Vitrine/VitrineLayout';
import { BlocPilote, GrilleModules } from '../Vitrine/ModulesEtFormules';
import { BlocFormulesParType } from '../Vitrine/BlocFormulesParType';

const Contenu: React.FC = () => {
    const { tokens } = useAmbiance();
    const demoButton = useDemoButton();
    return (
        <div style={{ ['--acc' as string]: tokens.acc }}>
            <style>{`.carte-vivante{transition:transform .18s ease,border-color .18s ease}.carte-vivante:hover{transform:translateY(-3px)}.carte-vivante:focus-visible{outline:2px solid var(--acc);outline-offset:2px}@media (prefers-reduced-motion: reduce){.carte-vivante,.carte-vivante:hover{transition:none;transform:none}}`}</style>
            <AmbianceBand veil="linear-gradient(180deg, rgba(5,6,10,.30) 0%, rgba(5,6,10,.18) 60%, rgba(5,6,10,.45) 100%)">
                <section className="max-w-[1160px] mx-auto px-5 py-16 md:py-20 text-center">
                    <h1 className="mx-auto max-w-[820px] text-[34px] md:text-[54px] font-semibold leading-[1.06] tracking-[-0.02em] mb-5">Les formules et les modules.</h1>
                    <p className="mx-auto max-w-[620px] text-[16px] text-content-muted leading-relaxed mb-7">Des formules et des prix par type d'établissement, ou vos modules à la carte. Planning et équipe gratuits jusqu'à 10 salariés.</p>
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        {demoButton('lg')}
                        <Pill variant="secondary" size="lg" href="#pilote">Devenir client pilote</Pill>
                    </div>
                </section>
            </AmbianceBand>
            <BlocFormulesParType />
            <GrilleModules />
            <BlocPilote />
        </div>
    );
};

/** /formules : les formules par type de client, leur tableau, les modules à la carte et le programme client pilote. */
export const VitrineFormulesPage: React.FC = () => (
    <VitrineLayout title="L'IAmani — Formules et modules">
        <Contenu />
    </VitrineLayout>
);

export default VitrineFormulesPage;
